import { render, staticRenderFns } from "./Reasons2.vue?vue&type=template&id=7047dd30&scoped=true"
import script from "./Reasons2.vue?vue&type=script&lang=ts"
export * from "./Reasons2.vue?vue&type=script&lang=ts"
import style0 from "./Reasons2.vue?vue&type=style&index=0&id=7047dd30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7047dd30",
  null
  
)

export default component.exports